import { defineComponent, onMounted, ref, toRef, } from "vue";
import MaintenanceScheduleYears from "./formQuestions/maintenanceScheduleYears.vue";
import MaintenanceScheduleModel from "./formQuestions/maintenanceScheduleModel.vue";
import MaintenanceScheduleTrim from "./formQuestions/maintenanceScheduleTrim.vue";
import MaintenanceScheduleMileage from "./formQuestions/maintenanceScheduleMileage.vue";
export default defineComponent({
    name: "MaintenanceScheduleFormQuestion",
    components: {
        MaintenanceScheduleYears,
        MaintenanceScheduleModel,
        MaintenanceScheduleTrim,
        MaintenanceScheduleMileage,
    },
    props: {
        question: {
            type: Object,
        },
    },
    setup(props) {
        const componentName = ref("");
        const questionAnswersLabelId = ref("");
        const question = toRef(props, "question");
        onMounted(() => {
            if (props.question) {
                componentName.value = props.question.answers.name;
                questionAnswersLabelId.value = props.question.answers.name + "Question";
            }
        });
        return {
            question,
            componentName,
            questionAnswersLabelId,
        };
    },
});
